import React from 'react';

const Page404 = () => {
  return <div>404 Error Occurred</div>;
};

export default Page404;
